import { createFileRoute } from "@tanstack/react-router";

import { CompanyDetailsPage } from "../../pages/dashboard/company-details/CompanyDetails.page";

export const Route = createFileRoute("/_protected/dashboard/company-details")({
  component: CompanyDetailsPage,
});
